function initYogaSpaceGallery(root) {
  if (root.dataset.ysReady === 'true') return;
  root.dataset.ysReady = 'true';
  const slides = Array.from(root.querySelectorAll('[data-ys-slide]'));
  const thumbs = Array.from(root.querySelectorAll('[data-ys-thumb]'));
  thumbs.forEach((thumb, index) => {
    thumb.addEventListener('click', () => {
      slides.forEach((slide, slideIndex) => {
        slide.hidden = slideIndex !== index;
        slide.classList.toggle('is-active', slideIndex === index);
      });
      thumbs.forEach((item, itemIndex) => {
        item.classList.toggle('is-active', itemIndex === index);
        item.setAttribute('aria-pressed', String(itemIndex === index));
      });
    });
  });
}
if (location.hostname === '127.0.0.1' && new URLSearchParams(location.search).get('ys_cue_bg') === 'purple') {
  document.documentElement.classList.add('ys-cue-bg-purple');
}
document.querySelectorAll('[data-ys-gallery]').forEach(initYogaSpaceGallery);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-ys-gallery]').forEach(initYogaSpaceGallery));

function initYogaSpaceProduct(root) {
  if (root.dataset.ysProductReady === 'true') return;
  root.dataset.ysProductReady = 'true';

  const picker = root.querySelector('variant-radios');
  if (picker && !picker.querySelector('input[type="radio"]:checked')) {
    customElements.whenDefined('variant-radios').then(() => {
      if (!picker.isConnected || picker.querySelector('input[type="radio"]:checked')) return;
      const firstPlan = picker.querySelector('input[type="radio"]:not(.disabled)');
      if (!firstPlan) return;
      firstPlan.checked = true;
      firstPlan.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  const timeline = root.querySelector('[data-ys-access-timeline]');
  if (!timeline) return;
  const now = new Date();
  const today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
  const yearStart = Date.UTC(2026, 0, 1);
  const accessDate = Date.UTC(2026, 11, 1);
  const progress = Math.min(100, Math.max(0, ((today - yearStart) / (accessDate - yearStart)) * 100));
  timeline.querySelector('[data-ys-access-fill]').style.width = `${progress}%`;
  timeline.classList.add('is-ready');
}

document.querySelectorAll('.yogaspace-product-main').forEach(initYogaSpaceProduct);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.yogaspace-product-main').forEach(initYogaSpaceProduct));

const ysPracticeMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
let ysPracticeFrame = 0;

function updateYogaSpacePracticeScroll() {
  ysPracticeFrame = 0;
  document.querySelectorAll('[data-ys-practice-scroll]').forEach(section => {
    const visual = section.querySelector('.ys-feature-visual--practice');
    if (!visual) return;
    if (ysPracticeMotion.matches) {
      visual.style.setProperty('--ys-practice-progress', '1');
      visual.style.setProperty('--ys-practice-shift', '0px');
      return;
    }
    const rect = section.getBoundingClientRect();
    const start = window.innerHeight * 0.85;
    const end = window.innerHeight * 0.15 - rect.height;
    const progress = Math.min(1, Math.max(0, (start - rect.top) / (start - end)));
    visual.style.setProperty('--ys-practice-progress', progress.toFixed(4));
    visual.style.setProperty('--ys-practice-shift', `${((0.5 - progress) * 16).toFixed(2)}px`);
  });
}

function scheduleYogaSpacePracticeScroll() {
  if (!ysPracticeFrame) ysPracticeFrame = requestAnimationFrame(updateYogaSpacePracticeScroll);
}

window.addEventListener('scroll', scheduleYogaSpacePracticeScroll, { passive: true });
window.addEventListener('resize', scheduleYogaSpacePracticeScroll);
ysPracticeMotion.addEventListener('change', scheduleYogaSpacePracticeScroll);
document.addEventListener('shopify:section:load', scheduleYogaSpacePracticeScroll);
scheduleYogaSpacePracticeScroll();


const ysLibraryMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
const ysLibraries = new Map();
let ysLibraryFrame = 0;

function updateYogaSpaceLibraryScroll() {
  ysLibraryFrame = 0;
  const updates = [];
  ysLibraries.forEach((state, panel) => {
    if (!panel.isConnected) {
      state.observer.disconnect();
      ysLibraries.delete(panel);
      return;
    }
    const top = panel.getBoundingClientRect().top;
    // Follow the panel through the viewport in either scroll direction. A tall
    // mobile panel keeps moving while it is read, without capturing page scroll.
    const start = window.innerHeight * 0.9;
    const end = window.innerHeight * 0.1 - panel.offsetHeight;
    const progress = ysLibraryMotion.matches ? 0
      : Math.min(1, Math.max(0, (start - top) / Math.max(1, start - end)));
    updates.push([panel, -state.travel * progress]);
  });
  updates.forEach(([panel, shift]) => panel.style.setProperty('--ys-library-shift', `${shift.toFixed(2)}px`));
}

function scheduleYogaSpaceLibraryScroll() {
  if (!ysLibraryFrame) ysLibraryFrame = requestAnimationFrame(updateYogaSpaceLibraryScroll);
}

function initYogaSpaceLibraries() {
  document.querySelectorAll('[data-ys-library-scroll]').forEach(panel => {
    if (ysLibraries.has(panel)) return;
    const tagToggle = panel.querySelector('[data-ys-more-tags]');
    const extraTags = panel.querySelector('[data-ys-extra-tags]');
    tagToggle?.addEventListener('click', () => {
      const expanded = tagToggle.getAttribute('aria-expanded') !== 'true';
      tagToggle.setAttribute('aria-expanded', String(expanded));
      tagToggle.textContent = expanded ? 'View fewer tags' : 'View more tags';
      extraTags.hidden = !expanded;
      scheduleYogaSpaceLibraryScroll();
    });
    const grid = panel.querySelector('.ys-library-grid');
    if (!grid) return;
    const cards = [...grid.children];
    if (cards.length < 4) return;
    const state = { travel: 0, observer: null };
    const measure = () => {
      const windowHeight = cards[3].offsetTop + cards[3].offsetHeight - cards[0].offsetTop;
      state.travel = Math.max(0, grid.offsetHeight - windowHeight);
      panel.style.setProperty('--ys-library-window-height', `${windowHeight}px`);
      panel.classList.toggle('is-scroll-ready', !ysLibraryMotion.matches);
      scheduleYogaSpaceLibraryScroll();
    };
    state.observer = new ResizeObserver(measure);
    ysLibraries.set(panel, state);
    state.observer.observe(grid);
    ysLibraryMotion.addEventListener('change', measure);
    measure();
    document.fonts.ready.then(measure);
  });
}

window.addEventListener('scroll', scheduleYogaSpaceLibraryScroll, { passive: true });
window.addEventListener('resize', scheduleYogaSpaceLibraryScroll);
document.addEventListener('shopify:section:load', initYogaSpaceLibraries);
initYogaSpaceLibraries();

